import useAxios from 'axios-hooks';

export interface ICgrScore {
  id: number;
  score: number;
  updateDate: string;
  year: number;
}

export const useGetCGRScore = (reportId: number, isPublished?: boolean) => {
  const endpoint = isPublished
    ? `/cgr-score/${reportId}/published`
    : `/cgr-score/${reportId}`;

  return useAxios<ICgrScore>({
    url: endpoint,
    method: 'GET',
  });
};
